<template>
  <transition name="pa-simple-fade" @enter="handleEnter">
    <section class="pa-section pa-section-story-card-carousel" ref="storyCardCarousel" v-if="isVisible">
      <swiper ref="storyCardSwiper" :options="swiperOptions">
        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">異界舞踏会物語: 序章</p>
              <p class="card-title-caption">（プロローグ）</p>
              
              <div class="slogan">
                <p class="has-text-left">ココハ、ハイカラ、</p>
                <p class="has-text-center">トーキョーシティー、</p>
                <p class="has-text-right"><AkibaharaText /></p>
              </div>

              <div class="text-field text-field-first">
                <p class="story-hooker-top">異世界からやってきた、</p>
                <p>不思議な、不思議な、仮面舞踏会の</p>
                <p>永遠に終わらない物語の</p>
                <p class="story-hooker story-hooker-bottom">はじまり、はじまり、</p>
                
                <p class="next-card-button-field">
                  <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">はじまり。</a>
                </p>
              </div>
            </div>
            
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">塔経市帝</p>
              <p class="card-title-caption">（トーキョーシティー）</p>

              <div class="text-field">
                <p class="line">ここは現代日本にとても良く似た</p>
                <p class="line">異界の地。</p>
                <p class="line">でも、似てないところが一つだけ</p>
                <p class="line-nomargin-top">・・・</p>
                <p class="line">この世界は知らない世界と繋がりやすい、異世界同士の経由地。</p>
                <p class="line">常に様々な異世界から不思議なものが流れ着きます。</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">つぎへ</a>
              </p>
            </div>
            
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">昭葉原</p>
              <p class="card-title-caption card-title-caption-akibahara">（<AkibaharaNoDot />）</p>

              <div class="text-field">
                <p class="line line-mini">塔経市帝のカワリモノが集まる街。</p>
                <p class="line line-mini">最先端の道具から怪しい骨董品まで何でも集まります。</p>
                <p class="line line-mini">塔経市帝の中でも一番異世界に繋がりやすい街。</p>
                <p class="line line-mini">異世界から塔経市帝に流れ着いた「モノ」や「コト」を処理する行政機関「２４区番外地管理局」の事務所があります。</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">つぎへ</a>
              </p>
            </div>
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">２４区番外地管理局</p>
              <p class="card-title-caption">（ニジュウヨンクバンガイチカンリキョク）</p>

              <div class="text-field">
                <p class="line line-mini">２４区番外地管理局の事務所には大きなソファがあります。</p>
                <p class="line line-mini">何時もソファを陣取って眠っているのは異世界から流れ着いた女の子。</p>
                <p class="line line-mini">ヲタンという世界からやってきた仮面舞踏会の立会人。</p>
                <p class="line line-mini">不思議な仮面の流れ着いた先に彼女の姿あり。</p>
                <p class="line line-mini">彼女の名前は「リリカ」２４区番外地管理局の担当処理物件です。</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">つぎへ</a>
              </p>
            </div>
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">異世界ヲタン</p>
              <p class="card-title-caption">（イセカイヲタン）</p>

              <div class="text-field">
                <p class="line line-mini">ヨタンは魔術の発達した世界。</p>
                <p class="line line-mini">魔法遣いが存在します。</p>
                <p class="line line-mini">ヲタンの人々は仮面を被り己の身分を隠して仮面舞踏会を開きます。</p>
                <p class="line line-mini">そんな仮面舞踏会の神聖なる守り神の不思議な仮面。</p>
                <p class="line line-mini">リリカは不思議な仮面を世話するための世話係。</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">つぎへ</a>
              </p>
            </div>
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">不思議な仮面と仮面舞踏会</p>
              <p class="card-title-caption">（フシギナカメントカメンブトウカイ）</p>

              <div class="text-field">
                <p class="line line-mini line-padding-mini">不思議な仮面にはオキテがあります。</p>
                <p class="line line-mini line-padding-mini">不思議な仮面がある場所では必ず仮面舞踏会を開かなければなりません。</p>
                <p class="line line-mini">でも困った事に塔経市帝には仮面舞踏会を開く習慣はありません。</p>
                <p class="line line-mini">２４区番外地管理局は昭葉原のカワリモノが作った最新エレキ技術</p>
                <p class="line line-mini">「ソーシャル・ネットワーク」を使って仮面舞踏会を開催することにしました。</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">つぎへ</a>
              </p>
            </div>
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">異界舞踏会</p>
              <p class="card-title-caption">（イカイブトウカイ）</p>

              <div class="text-field">
                <p class="line line-mini line-long">不思議な不思議なエレキ技術の</p>
                <p class="line line-mini line-nomargin-top">ソーシャル・ネットワーク</p>
                <p class="line line-mini">異世界からもアクセスできるようになってしまいました。</p>
                <p class="line line-mini">そこは塔経市帝じゃなくて東京都？</p>
                <p class="line line-mini">アキバハラじゃなくてアキハバラ？</p>
                <p class="line line-mini">似ているけどやっぱり違う、現代日本とつながってしまいました。</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">つぎへ</a>
              </p>
            </div>
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">akibahara.tokyo</p>
              <p class="card-title-caption card-title-caption-domain">（<AkibaharaTokyoText />）</p>
              
              <div class="text-field">
                <p class="line line-mini line-long">現代日本と繋がってしまった</p>
                <p class="line line-mini line-nomargin-top">ソーシャル・ネットワーク</p>
                <p class="line line-mini">困った２４区番外地管理局は塔経市帝の昭葉原とよく似た地名の東京都千代田区外神田(通称：秋葉原)に</p>
                <p class="line line-nomargin-top">秋葉原駐在所を開設。</p>
                <p class="line line-mini">akibahara.tokyoドメインの権利関係をクリアして、塔経市帝経由でヲタンに設置されたサーバーに接続出来るようにしました。</p>
                <p class="line line-mini">現代日本での仮面舞踏会の名前は
                <p class="line line-nomargin-top">「異界舞踏会・アキバトリカル」</p>
                <p class="line line-nomargin-top">としました。</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="nextCard()">つぎへ</a>
              </p>
            </div>
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <swiper-slide>
          <article class="pa-golden-box pa-story-card">
            <div class="content-wrapper" :class="storyCardContentClass">
              <StoryCardLogo class="story-card-logo" />
              <p class="card-title">塔経市帝電子的通行許可発行所</p>
              <p class="card-title-caption">（トーキョーシティーパスポートセンター）</p>
              
              <div class="text-field">
                <p class="line line-mini">２４区番外地管理局秋葉原駐在所では塔経市帝への電子的接続を許可する電子異界通行許可証(パスポート)の発行を行っています。</p>
                <p class="line">ご希望の方はこのページよりお申込みください。</p>
                <p class="line story-hooker-last-down">でも、その前に、もう少しだけ、</p>
                <p class="line line-last-down">ストーリーを紐解いてから・・・</p>
              </div>

              <p class="next-card-button-field">
                <a href="javascript:void(0);" class="next-button" v-on:click="handleJumpToIntro">つぎへ</a>
              </p>
            </div>
            <div class="pa-background"><AkibaharaQiumo /></div>
            <div class="disabled-overlay"></div>
          </article>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>
  </transition>
</template>

<script>
import StoryCardLogo  from '@/components/FrontParts/StoryCardSwiper/Images/story_card_logo.svg?inlineN'
import AkibaharaText  from '@/components/FrontParts/StoryCardSwiper/Images/akibahara_text.svg?inlineN'
import AkibaharaNoDot from '@/components/FrontParts/StoryCardSwiper/Images/akibahara_no_dot.svg?inlineN'
import AkibaharaTokyoText from '@/components/FrontParts/StoryCardSwiper/Images/akibahara_tokyo_text.svg?inlineF'

import AkibaharaQiumo from '@/components/FrontParts/StoryCardSwiper/Images/bk_qiumo1.svg?inlineN'

export default {
  props : {
    isVisible : {
      default: false
    }
  },

  components : {
    StoryCardLogo,
    AkibaharaText,
    AkibaharaNoDot,
    AkibaharaTokyoText,
    AkibaharaQiumo
  },

  data(){
    return {
      storyCardContentClass : [],

      swiperOptions         : {
        slidesPerView   : 1,
        loop            : false,
        speed           : 800,
        pagination      : {
          el          : 'section.pa-section-story-card-carousel .swiper-pagination',
          clickable   : true
        },
        on: {
          slideChangeTransitionStart(){
            const slides = document.querySelectorAll('.pa-section-story-card-carousel .swiper-slide');

            for(var i = 0; i < slides.length; i++){
              const backgroudObj = slides[i].querySelector('.pa-background');
              backgroudObj.classList.add('pa-backtround-hide');
            }
          },

          slideChangeTransitionEnd(){
            const slides = document.querySelectorAll('.pa-section-story-card-carousel .swiper-slide');

            for(var i = 0; i < slides.length; i++){
              const backgroudObj = slides[i].querySelector('.pa-background');
              backgroudObj.classList.remove('pa-backtround-hide');
            }
          }
        }
      }
    };
  },

  computed : {
    swiper() {
      return this.$refs.storyCardSwiper.$swiper;
    }
  },

  methods : {
    slideDisabled(slideObj){
      return new Promise((resolve) => {
        const overlayObj = slideObj.querySelector('.disabled-overlay');

        slideObj.classList.remove('swiper-slide-scale-up');

        overlayObj.addEventListener('animationend', async () => {
          overlayObj.removeEventListener('animationend', this);

          resolve();
        });

        overlayObj.classList.add('disabled-overlay-visible');
      });
    },

    slideScaleDown(slideObj){
      return new Promise((resolve) => {
        slideObj.classList.add('swiper-slide-scale-down');

        setTimeout(() => {
          resolve();
        }, 400);
      });
    },

    waitSlideHasChange(slideNum = 0){
      return new Promise((resolve) => {
        const intervalId = setInterval(() => {
          if((this.swiper.activeIndex + 1) === slideNum){
            resolve();
          }
        }, 100);

        setTimeout(() => {
          clearInterval(intervalId);
          resolve();
        }, 5000);
      });
    },

    slideScaleUpAndClearDisabled(slideObj){
      return new Promise((resolve) => {
        const overlayObj = slideObj.querySelector('.disabled-overlay');

        slideObj.classList.add('swiper-slide-scale-up');
        overlayObj.classList.add('disabled-overlay-hide');

        setTimeout(() => {
          slideObj.classList.remove('swiper-slide-turn-to-disabled');

          resolve();
        }, 700);
      });
    },

    clearAnimationClass(slideObj){
      const overlayObj = slideObj.querySelector('.disabled-overlay');

      slideObj.classList.remove('swiper-slide-scale-down');
      overlayObj.classList.remove('disabled-overlay-visible');

      slideObj.classList.remove('swiper-slide-scale-up');
      overlayObj.classList.remove('disabled-overlay-hide');
    },

    async nextCard(slideNum = null){
      slideNum = (this.swiper.activeIndex + 1);

      if( (slideNum + 1) > this.swiper.slides.length) return;

      const currentSlide = this.$refs.storyCardCarousel.querySelector('.swiper-slide:nth-child('+(slideNum)+')');
      const nextSlide    = this.$refs.storyCardCarousel.querySelector('.swiper-slide:nth-child('+(slideNum + 1)+')');

      await this.slideDisabled(currentSlide);

      await this.slideScaleDown(currentSlide);

      nextSlide.classList.add('swiper-slide-turn-to-disabled');

      this.swiper.slideTo(slideNum);

      await this.waitSlideHasChange((slideNum + 1));

      await this.slideScaleUpAndClearDisabled(nextSlide);

      this.clearAnimationClass(nextSlide);
      this.clearAnimationClass(currentSlide);
    },
    
    initializeCardHeight(){
      this.storyCardContentClass = [];

      const storyCardDom = this.$refs.storyCardCarousel.querySelectorAll('article.pa-story-card');
      
      const heightList = [];
      for(let i = 0; i < storyCardDom.length; i++){
        heightList.push(storyCardDom[i].offsetHeight);
      }

      // 一番高い高さを取得します。
      const maxHeight = this._.max(heightList);

      const buttonHeightList = [];
      const buttonDom = this.$refs.storyCardCarousel.querySelectorAll('article.pa-story-card p.next-card-button-field');
      for(let i = 0; i < buttonDom.length; i++){
        buttonHeightList.push(buttonDom[i].offsetHeight);
      }

      // 一番高い高さを取得します。
      const maxButtonHeight = this._.max(buttonHeightList);

      const contentHeight = maxHeight + maxButtonHeight;

      for(let i = 0; i < storyCardDom.length; i++){
        storyCardDom[i].style.height = contentHeight+'px';
      }

      this.storyCardContentClass = ['content-wrapper-on'];
    },

    handleJumpToIntro(){
      this.$parent.$emit('startMainFieldAnimation');
    },

    handleEnter(){
      this.initializeCardHeight();
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@import "@/assets/scss/mixins.scss";

@keyframes storyCardOverlayFade {
  0%  {
    opacity:0;
  }
  100% {
    opacity:.6;
  }
}

@keyframes coverScaleDown
{
  0%  {
    transform:scale(1);
  }
  100% {
    transform:scale(.9);
  }
}

@keyframes heartbeat
{
  0%   {
    transform: scale(.8);
    opacity:.55;
  }
  20%  {
    transform: scale(1);
    opacity:.55;
  }
  40%  {
    transform: scale(.8);
    opacity:0;
  }
  60%  {
    transform: scale(1);
    opacity:.55;
  }
  80%  {
    transform: scale(.8);
    opacity:0;
  }
  100% {
    transform: scale(.8);
    opacity:.55;
  }
}

.pa-section{
  &-story-card-carousel{
    background: radial-gradient($body-background-light-darker, $body-background-primary 60%);

    @include until($tablet) {
      margin-top:-10px;
    }

    .pa-golden-box{
      @include pa-golden-box(8px, 12px, 0);

      margin:0 10px;

      font-size:.8rem;
      line-height: 1.3rem;
      text-align: center;

      @include from($tablet) {
        width:500px;
        margin:0 auto;
        font-size:1.1rem;
      }

      &::after {
        @include pa-golden-box-after();
      }
    }

    .pa-story-card{
      user-select: none;
      box-shadow: 1px 0px 25px #703c50;
      position: relative;

      p{
        padding:0 .5rem;
        text-shadow: $golden-box-background-x-darker 0 0 1rem;
      }

      svg.story-card-logo{
        display:block;
        margin:.8rem auto .45rem;
        width:7rem;
        fill:#7c5505;

        @include from($tablet) {
          width:11rem;
        }
      }
      
      p.card-title{
        line-height:1.4rem;
        font-size:1.3rem;

        @include from($tablet) {
          line-height:1.8rem;
          font-size:1.8rem;
        }
      }

      p.card-title-caption{
        margin:0 .5rem .2rem;
        padding:0 0 .2rem;
        font-size:.8rem;
        line-height: 1.6rem;
        
        @include from($tablet) {
          font-size:1rem;
          line-height: 1.8rem;
        }

        &-akibahara{
          svg{
            display: inline;
            width:4rem;
            

            @include from($tablet) {
              width:5rem;
            }
          }
        }

        &-domain{
          svg{
            vertical-align: middle;
            width:10.4rem;
            fill: #4a4a4a;

            @include from($tablet) {
              width:13rem;
            }
          }
        }
      }

      div.slogan{
        margin:.2rem .5rem 0;
        border-top:.1rem solid $golden-box-separator;

        p{
          font-size:1.2rem;
          padding:0 1rem .55rem;

          @include from($tablet) {
            padding:0 2rem;
            margin-bottom:1rem;
          }

          &.has-text-left{
            margin-top:.6rem;
          }

          &.has-text-right{
            padding-bottom:.6rem;

            svg{
              display: inline;
              width: calc(1.05rem * 6);

              @include from($tablet) {
                width:8rem;
              }
            }
          }
        }
      }

      div.text-field{
        margin:0 .5rem;
        border-top:.1rem solid $golden-box-separator;
        padding-top:.5rem;

        &-first{
          padding-top:3rem;
        }

        p{
          font-size:1.2rem;
          line-height: 1.25;
          padding:.4rem 0 0;

          @include from($tablet) {
            font-size:1.4rem;
            padding-top:.8rem;
          }

          .line{
            line-height: 1.5rem;

            &-nomargin-top{
              padding-top:.3rem;
              margin-top:0;
            }

            &-mini{
              margin-top:.4rem;
            }

            &-padding-mini{
              padding:0 .3rem;
            }

            &-long{
              font-size:1.18rem;

              @include from($tablet) {
                font-size:1.4rem;
              }
            }

            &-nomargin-top{
              padding-top:.3rem;
              margin-top:0;
            }

            &-last-down{
              margin-top:3rem;
            }
          }
        }

        .next-card-button-field{
          position: static;
        }
      }

      .next-card-button-field{
        width:100%;
        position: absolute;
        left:0;
        bottom:0;
        padding-bottom:1rem;
        margin:0;
        padding-left:0;
        padding-right:0;

        a.next-button{
          max-width: 200px;
          margin:0 auto;
          border-radius: 12px;
          font-size:1.1rem;
          line-height: 1.4rem;

          @include from($tablet) {
            max-width: 250px;
            font-size:1.3rem;
            line-height: 1.6rem;
          }

          display: block;
          box-sizing: border-box;
          border:5px solid $button-border;
          text-shadow: $button-text-shadow 0 0 1rem;

          background-color:$button-background;
          // background:linear-gradient(0deg, $button-background, $button-background-darker);
          color:$button-text;

          &:hover{
            color:$button-text-hovered;
          }

          &:active{
            color:$button-text-active;
            background:linear-gradient(0deg, $button-background, $button-background-darker);
          }
        }
      }

      div.content-wrapper{
        width:100%;
        height: 100%;

        &-on{
          position: absolute;
          top:0;
          left:0;
          z-index: 5;
        }
      }

      div.disabled-overlay,
      div.light-down-cover{
        display: none;
        position:absolute;
        z-index: 10;
        border-radius: 8px;
        background-image: radial-gradient(#676358, #4f4837);
        top:-8px;
        left:-8px;
        width:100%;
        height:100%;
        padding:8px;

        &-visible{
          display:block;
          opacity: .6;
          animation: storyCardOverlayFade .7s normal ease-in;
        }

        &-hide{
          opacity:0;
          animation: storyCardOverlayFade .7s reverse ease-in-out;
        }
      }

      .pa-background{
        width:100%;
        height:100%;
        overflow: hidden;
        position: absolute;
        top:-1000px;
        top:0;
        left:0;
        z-index: 4;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity:1;
        transition: opacity .3s;

        &-down{
          opacity:1;
        }

        &-hide{
          opacity:0;
        }

        svg{
          opacity: .55;
          width:75%;
          height:75%;
          animation: heartbeat 20s infinite;
          animation-timing-function:ease-in-out;
          z-index: 10;
          stroke:#dbc6a9;

          .cls-2{
            fill:#dbc6a9;
          }
        }
      }
    }

    .swiper-pagination{
      margin-top:.8rem;
      position: static;

      .swiper-pagination-bullet{
        box-sizing: border-box;
        border:4px solid $swiper-pagination-bullet-border;
        background: radial-gradient($swiper-pagination-bullet-background-darker 70%, $swiper-pagination-bullet-background);

        width:20px;
        height: 20px;
        border-radius: 50%;
        margin-right:15px;

        opacity: .9;
      }

      .swiper-pagination-bullet-active{
        background: radial-gradient($swiper-pagination-bullet-active-background-darker 70%, $swiper-pagination-bullet-active-background);
      }

      .swiper-pagination-bullet::before{
        content: "";
      }
    }

    .swiper-slide{
      &-scale-down{
        transform: scale(.9);
        animation: coverScaleDown .7s normal ease-in;
      }

      &-scale-up{
        transform: scale(1);
        animation: coverScaleDown .7s reverse ease-in;
      }

      &-turn-to-disabled{
        transform: scale(.9);

        div.disabled-overlay{
          display: block;
          opacity: .6;
        }
      }
    }
  }
}
</style>